<script>
    
    import { slide, blur } from 'svelte/transition';
    import tippy from "sveltejs-tippy";
    import WidgetBox from './WidgetBox.svelte';
    import TemperatureSlider from './util/TemperatureSlider.svelte';
    import { pin } from './pincelate-store.js';
    import { tick } from 'svelte';
    import { manipulate } from './pincelate-funcs.js';
    import ExampleButton from './util/ExampleButton.svelte';

    let frame = async() => new Promise(resolve => { requestAnimationFrame(resolve); });

    let soundsArray = [
        { name: 'eee',
          features: {
            'hgh': -4, 'smh': -2.5, 'lmd': 3.5,
            'umd': 3.5, 'low': 4, 'fnt': -4,
            'bck': 4, 'vwl': 2.5, 'end': -2.5
          }
        },
        { name: 'ooo',
          features: {
            'rnd': -4, 'smh': -2.5, 'hgh': -4,
            'bck': -4, 'unr': 4, 'lmd': 4,
            'umd': 4, 'vwl': 2.5, 'end': -2.5
          }
        },
        { name: 'ahhh',
          features: {
            'lmd': -4, 'umd': 4, 'hgh': 4,
            'low': -4, 'fnt': 4, 'bck': -4,
            'vwl': 2.5
          }
        },
        { name: 'errr',
          features: {
            'rzd': -6
          }
        },
        { name: 'mpbfmpb',
          features: {
            'blb': -6, 'lbd': -6
          }
        },
        { name: 'kngkgng',
          features: { 'vel': -8 }
        },
        { name: 'dstnsdt',
          features: {
            'alv': -10, 'vel': 10, 'blb': 10,
            'lbd': 10
          }
        },
        { name: 'nasal',
          features: { 'nas': -8 }
        },
        { name: 'headcold',
          features: {
            'nas': 500, 'stp': -2.3, 'frc': 2.5,
            'vcd': -2.8, 'vls': 10, 'end': -1.7
          }
        },
        { name: 'hard',
          features: { 'vcd': 5, 'vls': -5 }
        },
        { name: 'soft',
          features: {
            'vcd': -10, 'vls': 10, 'stp': 4,
            'frc': -2, 'lat': -3, 'apr': -3,
            'nas': -2, 'end': -3.5
          }
        },
        { name: 'breathy',
          features: {
            'glt': -6, 'apr': -6, 'vls': -2,
            'end': -1.5
          }
        },
        { name: 'hiss',
          features: {
            'alv': -6, 'frc': -6, 'vls': -6,
            'vcd': 6, 'pla': 6, 'end': -3.5
          }
        }
    ];

    let soundGroups = [
        ['eee', 'ooo', 'ahhh', 'errr'],
        ['hard', 'soft'],
        ['breathy', 'hiss'],
        ['mpbfmpb', 'kngkgng', 'dstnsdt'],
        ['nasal', 'headcold']
    ];

    function calcFeatureMap(st) {
        let total = {};
        for (const [key, sliderVal] of Object.entries(st)) {
            if (sliderVal > 0) {
                for (const [feat, featVal] of Object.entries(soundsArrayLookup[key])) {
                    if (!total.hasOwnProperty(feat)) {
                        total[feat] = 0;
                    }
                    total[feat] += sliderVal * featVal;
                }
            }
        }
        return total;
    }

    function calcLetterMap(st) {
        let out = {};
        for (const [key, val] of Object.entries(st)) {
            if (!val) {
                out[key] = 100
            }
        }
        return out;
    }

    let soundsArrayLookup = {};
    for (let item of soundsArray) {
        soundsArrayLookup[item.name] = item.features;
    }
    console.log("soundsArrayLookup", soundsArrayLookup);

    let sliderState = {};

    function resetSliderState() {
        for (let item of soundsArray) {
            sliderState[item.name] = 0;
        }
    }

    async function manipulateWrap() {
        history.push(currentText.slice());
        decodingInProgress = true;
        await tick();
        let iter = manipulate(
            $pin,
            currentText,
            calcFeatureMap(sliderState),
            {},
            temperature
        );
        setTimeout(async function() {
            for await (let ct of iter) {
                currentText = ct;
                await frame();
            }
            decodingInProgress = false;
            await tick();
        }, 100);
    }

    resetSliderState();
    sliderState['eee'] = 0.75;

    let currentText = 'How doth the little crocodile improve his shining tail...';
    let history = [currentText];

    let temperature = 0.25;

    let decodingInProgress = false;

    $: console.log(sliderState, calcFeatureMap(sliderState));

</script>

<style>
    h4.slider-header {
        margin-bottom: 0;
        text-transform: uppercase;
        margin-left: 1.5rem;
        margin-top: 0;
        font-size: 1rem;
        font-weight: normal;
        margin-bottom: 0.5rem;
        cursor: pointer;
    }
    textarea {
        width: 100%;
        margin: 0;
        padding: 0.75rem;
        border: 0.15rem black solid;
        height: 6em;
    }
    .sounds-container {
        display: inline-flex;
        flex-direction: column;
        width: 100%;
        justify-content: flex-start;
        height: min-content;
        margin: 0 0 0.5rem 0;
    }
    @media screen and (max-width: 39.999rem) {
        .sound-groups {
            columns: 2;
        }
    }
    @media screen and (min-width: 40rem) {
        .sound-groups {
            columns: 3;
        }
    }
    .sound-groups {
        height: min-content;
        width: 100%;
        column-gap: 0.5rem;
        padding: 0 0.5rem 0.5rem 0.5rem;
    }
    /*@media screen and (max-width: 39.999rem) {
        .sounds-container {
            grid-template-columns: 1fr 1.5fr 1fr 1.5fr;
        }
    }
    @media screen and (min-width: 40rem) {
        .sounds-container {
            grid-template-columns: 1fr 1.5fr 1fr 1.5fr 1fr 1.5fr;
        }
    }*/

    .sound-slider {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .sounds-container input[type=range] {
        display: inline-block;
        vertical-align: middle;
        margin: 0;
    }
    
    .sound-slider label {
        text-align: right;
        display: inline-block;
        margin: 0;
        font-size: 0.75rem;
        font-weight: normal;
    }

    /* slider madness, generated with http://danielstern.ca/range.css/#/ */
    input[type=range] {
        width: 55%;
        margin: 0.75rem 0;
        background-color: transparent;
        -webkit-appearance: none;
        border: none;
    }
    input[type=range]:focus {
        outline: none;
    }
    input[type=range]::-webkit-slider-runnable-track {
        background: #eeeeee;
        border: 0;
        width: 100%;
        height: 0.15rem;
        cursor: pointer;
        margin: 0.5rem 0 0.5rem 0;
    }
    input[type=range]::-webkit-slider-thumb {
        margin-top: -0.75rem;
        width: 1.75rem;
        height: 1.75rem;
        background-image: url(/assets/svg/_slider-medium-cyan.svg);
        background-color: transparent;
        border: none;
        outline: none;
        background-size: contain;
        cursor: pointer;
        -webkit-appearance: none;
    }
    input[type=range]:focus::-webkit-slider-runnable-track {
        background: #eeeeee;
    }
    input[type=range]::-moz-range-track {
        background: #eeeeee;
        border: 0;
        width: 100%;
        height: 0.15rem;
        cursor: pointer;
    }
    input[type=range]::-moz-range-thumb {
        width: 1.75rem;
        height: 1.75rem;
        background-image: url(/assets/svg/_slider-medium-cyan.svg);
        background-color: transparent;
        border: none;
        outline: none;
        background-size: contain;
        cursor: pointer;
    }
    input[type=range]::-ms-track {
        background: transparent;
        border-color: transparent;
        border-width: 0.75rem 0;
        color: transparent;
        width: 100%;
        height: 0.15rem;
        cursor: pointer;
    }
    input[type=range]::-ms-fill-lower {
        background: #eeeeee;
        border: 0;
    }
    input[type=range]::-ms-fill-upper {
        background: #eeeeee;
        border: 0;
    }
    input[type=range]::-ms-thumb {
        width: 1.75rem;
        height: 1.75rem;
        background-image: url(/assets/svg/_slider-medium-cyan.svg);
        background-color: transparent;
        border: none;
        outline: none;
        background-size: contain;
        cursor: pointer;
        margin-top: 0px;
    /*Needed to keep the Edge thumb centred*/
    }
    input[type=range]:focus::-ms-fill-lower {
        background: #eeeeee;
    }
    input[type=range]:focus::-ms-fill-upper {
        background: #eeeeee;
    }

    .revert-button {
        background-image: url("/assets/svg/_minus-medium-cyan.svg");
    	background-size: 100%;
	    background-origin: border-box;
        width: 1.25rem;
        height: 1.25rem;
        border-radius: 0.75rem;
        border: 0.15rem white solid;
    }
</style>

<WidgetBox on:reset={resetSliderState}>

    <span slot="title"><span style="font-size: 0.6em;">Mouthfeel Tuner</span></span>
    <span slot="tagline">Type a phrase and play with its sounds</span>

    <div slot="widget" id="phonetic-editor">

        <div class="box cyan lev1" style="position: relative; z-index: 1;" class:jittering={decodingInProgress} transition:slide|local>
            <textarea class="lev2 light light-border" spellcheck="false" placeholder="type something here..." bind:value={currentText}></textarea>
        </div>

        <div class="control-container" transition:slide|local="{{delay: 150}}">
            <div class="dark box control-tab secondary-action lev1">
                <button class="revert-button hovery"
                    id="revert"
                    disabled={decodingInProgress}
                    title="Revert"
                    on:click={() => {currentText = history.pop()}}>&nbsp;</button>
                <label for="revert">Revert</label>
            </div>
            <div class="light box control-tab primary-action lev1">
                <button id="apply" class="action-button cyan hovery"
                disabled={decodingInProgress}
                title="Apply" on:click={manipulateWrap}>&nbsp;</button>
                <label for="apply">Apply</label>
            </div>
        </div>

        <div class="box light lev1" style="padding-left: 0; padding-right: 0; padding-bottom: 0;" transition:slide|local="{{delay: 250}}">
            <h4 class="slider-header"><span use:tippy="{{content: 'Adjust sliders to add phonetic characteristics to text when respelling.'}}">
                WARP SOUNDS
                <div class="help">&nbsp;</div></span>
            </h4>
            <div class="sound-groups">
            {#each soundGroups as group}
                <div class="sounds-container box dark lev1">
                {#each group as cname}
                    <div class="sound-slider">
                        <label for={cname}>{cname}</label>
                        <input id={cname} type="range" min="0" max="1" step="0.25" bind:value={sliderState[cname]} />
                    </div>
                {/each}
                </div>
            {/each}
            </div>
        </div>

    </div>

    <div slot="sidetab">
        <TemperatureSlider bind:temperature={temperature} thumbURL="/assets/svg/_weird-vertical-cyan.svg" />
    </div>

    <div slot="modalContent">

        <p>The <b>Mouthfeel Tuner</b> rewrites a text so that the words feel different in your mouth.</p>

        <h4>How to use it</h4>

        <ul>
            <li>The sliders in the <b>Warp Sounds</b> section control how the word's "mouthfeel" is changed.
                Pick a few that interest you and move the slider to the right.</li>
            <li>Hit 
            <ExampleButton src="/assets/svg/_action-large-cyan.svg" alt="Action">Apply</ExampleButton>.
            This will respell the text in the text box, changing mouthfeel according to the positions of the sliders.</li>
            <li>Hit
            <ExampleButton src="/assets/svg/_minus-medium-cyan.svg" alt="Revert">Revert</ExampleButton>
            to restore the text to whatever it was before you most recently applied changes.</li>
        </ul>
            
        <h4>Tips and tricks</h4>

        <ul>
            <li>Some of the slider labels describe, others demonstrate!
            Try reading labels out loud to understand what they'll do to
            the text.</li>
            <li>The slider values build on each other, so don't be afraid to mix and match.</li>
            <li>Lower values on the <b>Weird ↔︎ Normal</b> slider lead to safe, boring output. Higher values 
                push the model toward output that is less likely, but maybe more fun and expressive.</li>
            <li>Make sure to try your text's new mouthfeel on for size. Read it out loud for family and
            friends!</li>
        </ul>

    </div>

</WidgetBox>